import Pagination from './pagination';
export default {
    install(Vue) {
        Vue.component("my-pagination", Pagination)
    }
}


// WEBPACK FOOTER //
// ./src/components/pagination/index.js